/**
 * Demographic confirmation - controls which patient fields are banner-confirmed vs asked in flow
 */

import type { PatientInput } from "./patient.types";

export type AmendmentReason =
  | "patient_disclosed"
  | "record_out_of_date"
  | "record_incorrect"
  | "other";

export const DEFAULT_AMENDMENT_REASON_LABELS: Record<AmendmentReason, string> = {
  patient_disclosed: "Patient disclosed during consultation",
  record_out_of_date: "Record out of date",
  record_incorrect: "Record incorrect",
  other: "Other (specify)",
};

export interface Amendment {
  field: keyof PatientInput;
  originalValue: unknown;
  newValue: unknown;
  reason: AmendmentReason;
  reasonNote?: string;
  amendedAt: string;
}

export interface BannerFieldShowWhen {
  /** Field is only shown when patient age (years) is strictly less than this. */
  patientAgeUnder?: number;
  /** Field is only shown when patient age (years) is at least this. */
  patientAgeAtLeast?: number;
}

export interface BannerFieldConfig {
  field: keyof PatientInput;
  label: string;
  type: "boolean" | "date" | "number" | "string" | "select" | "sensitive_attribute";
  selectOptions?: { value: string; label: string }[];
  amendmentReasons?: AmendmentReason[];
  helpText?: string;
  sensitiveAttribute?: {
    consentBasis: string;
    purposeOfProcessing: string;
  };
  showWhen?: BannerFieldShowWhen;
}

export interface DemographicConfiguration {
  bannerFields: BannerFieldConfig[];
}
